import {main_phaser} from "./MadnesApp";
import {he_scale, madnes_objects, wi_scale} from "./madnes_variables";
import {madnes_tint} from "./madnes_object";
import {madnes_interpolate_color} from "./madnes";

export function madnes_tween_func(name) {
    switch(name)
    {
        case "default": return Phaser.Easing.Default;
        case "linear":	return Phaser.Easing.Linear.None;

        case "back_in": 		return Phaser.Easing.Back.In;
        case "back_in_out":		return Phaser.Easing.Back.InOut;
        case "back_out":		return Phaser.Easing.Back.Out;

        case "bounce_in": 		return Phaser.Easing.Bounce.In;
        case "bounce_in_out": 	return Phaser.Easing.Bounce.InOut;
        case "bounce_out": 		return Phaser.Easing.Bounce.Out;

        case "circular_in": 		return Phaser.Easing.Circular.In;
        case "circular_in_out":		return Phaser.Easing.Circular.InOut;
        case "circular_out": 		return Phaser.Easing.Circular.Out;

        case "cubic_in": 		return Phaser.Easing.Cubic.In;
        case "cubic_in_out": 	return Phaser.Easing.Cubic.InOut;
        case "cubic_out": 		return Phaser.Easing.Cubic.Out;

        case "elastic_in": 		return Phaser.Easing.Elastic.In;
        case "elastic_in_out": 	return Phaser.Easing.Elastic.InOut;
        case "elastic_out": 	return Phaser.Easing.Elastic.Out;

        case "exponential_in": 		return Phaser.Easing.Exponential.In;
        case "exponential_in_out": 	return Phaser.Easing.Exponential.InOut;
        case "exponential_out": 	return Phaser.Easing.Exponential.Out;

        case "power0": 		return Phaser.Easing.Power0;
        case "power1": 		return Phaser.Easing.Power1;
        case "power2": 		return Phaser.Easing.Power2;
        case "power3": 		return Phaser.Easing.Power3;
        case "power4": 		return Phaser.Easing.Power4;

        case "quadratic_in": 		return Phaser.Easing.Quadratic.In;
        case "quadratic_in_out": 	return Phaser.Easing.Quadratic.InOut;
        case "quadratic_out": 		return Phaser.Easing.Quadratic.Out;

        case "quartic_in": 		return Phaser.Easing.Quartic.In;
        case "quartic_in_out": 	return Phaser.Easing.Quartic.InOut;
        case "quartic_out": 	return Phaser.Easing.Quartic.Out;

        case "quintic_in": 		return Phaser.Easing.Quintic.In;
        case "quintic_in_out": 	return Phaser.Easing.Quintic.InOut;
        case "quintic_out": 	return Phaser.Easing.Quintic.Out;

        case "sinusoidal_in": 		return Phaser.Easing.Sinusoidal.In;
        case "sinusoidal_in_out":	return Phaser.Easing.Sinusoidal.InOut;
        case "sinusoidal_out": 		return Phaser.Easing.Sinusoidal.Out;

        case "equal_power_in":		return function(x) {
            if(x === 1) { return 1; }
            return 1 - Math.cos(x * 0.5 * Math.PI);
        }
        case "equal_power_out":		return function(x) {
            if(x === 0) { return 0; }
            return Math.cos((1.0 - x) * 0.5 * Math.PI);
        }

    }
    return Phaser.Easing.Default;
}

function madnes_tween_init_settings(obj, settings, props)
{
    var mObj = obj;

    if(typeof obj === 'string') {
        mObj = madnes_objects[obj];
    }

    if(props.scale)
    {
        mObj = madnes_objects[obj].scale;
    }

    if(!props.scale)
    {
        if(typeof settings['x'] === "object") //array
        {
            for(var i in settings['x'])
            {
                settings['x'][i] *= wi_scale;
            }
        }
        else if(typeof settings['x'] !== "undefined")
        {
            settings['x'] *= wi_scale;
        }

        if(typeof settings['y'] === "object") //array
        {
            for(var i in settings['y'])
            {
                settings['y'][i] *= he_scale;
            }
        }
        else if(typeof settings['y'] !== "undefined")
        {
            settings['y'] *= he_scale;
        }
    }

    if(typeof props.delay == "undefined")
    {
        props.delay = 0;
    }

    if(typeof props.count == "undefined")
    {
        props.count = 0;
    }

    if(typeof props.callback == "undefined")
    {
        props.callback = false;
    }

    if(typeof props.yoyo == "undefined")
    {
        props.yoyo = false;
    }

    if(typeof props.easing == "undefined")
    {
        props.easing = madnes_tween_func("");
    }

    if(typeof props.easing == "string")
    {
        props.easing = madnes_tween_func(props.easing);
    }

    return {
        'obj': mObj,
        'settings': settings,
        'props': props
    };
}

/**
 * @param {Phaser.Tween} tw
 * @param {Object} props
 * @returns {Phaser.Tween}
 */
function madnes_init_callbacks(tw, props)
{
    if(props['callback'])
    {
        tw.onComplete.add(props['callback']);
    }

    if(props['onStart'])
    {
        tw.onStart.add(props['onStart']);
    }

    if(props['update'])
    {
        tw.onUpdateCallback(props['update']);
    }

    if(props['repeatDelay'])
    {
        tw.repeatDelay(props['repeatDelay']);
    }

    if(props['yoyoDelay'])
    {
        tw.yoyoDelay(props['yoyoDelay']);
    }

    if(props['onLoop'])
    {
        tw['onLoop'].add(props['onLoop']);
    }

    if(props['onRepeat'])
    {
        tw.onRepeat.add(props['onRepeat']);
    }

    return tw;
}

export function madnes_tween_to(obj, settings, props, phaser = main_phaser)
{
    var set = madnes_tween_init_settings(obj, settings, props);
    obj = set['obj'];
    settings = set['settings'];
    props = set['props'];

    var tw = phaser.add.tween(obj).to(settings, props.duration, props.easing, true, props.delay, props.count, props.yoyo);
    madnes_init_callbacks(tw, props);

    return tw;
}

export function madnes_tween_from(obj, settings, props)
{
    var set = madnes_tween_init_settings(obj, settings, props);
    obj = set['obj'];
    settings = set['settings'];
    props = set['props'];

    var tw = main_phaser.add.tween(obj).from(settings, props.duration, props.easing, true, props.delay, props.count, props.yoyo);
    madnes_init_callbacks(tw, props);

    return tw;
}

/**
 * @param {string} name
 * @param {Object} props - props.duration, props.startColor, props.endColor
 */
export function madnes_tween_tint(name, props)
{
    var colorBlend = { 'step': 0 };
    props['step'] = 0;

    props['update'] = function() {
        madnes_tint(name, madnes_interpolate_color(props['startColor'], props['endColor'], 100, colorBlend['step']));
    };

    return madnes_tween_to(colorBlend, { 'step': 100 }, props);
}

export function madnes_tween_bezier(tween)
{
    tween.interpolation(function(v, k){
        return Phaser.Math.bezierInterpolation(v, k);
    });
}

export function madnes_tween_catmull(tween)
{
    tween.interpolation(function(v, k){
        return Phaser.Math.catmullRomInterpolation(v, k);
    });
}

export function madnes_tween_start(tween)
{
    tween.start();
}

export function madnes_tween_stop(tween)
{
    tween.stop();
}

export function madnes_tween_pause(tween)
{
    tween.pause();
}

export function madnes_tween_resume(tween)
{
    tween.resume();
}